module.exports = __webpack_public_path__ + "img/bg_function03_1_m.f981ce90.png";